import { ActionButtonType } from "@octopusdeploy/design-system-components";
import type { ProjectResource } from "@octopusdeploy/octopus-server-client";
import { VariableSetContentType } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { Action, useAnalyticActionDispatch } from "~/analytics/Analytics";
import VariableSetSelector from "~/areas/variables/VariableSetSelector/index";
import { repository } from "~/clientInstance";
import type { DoBusyTask } from "~/components/DataBaseComponent/index";
import OpenDialogButton from "~/components/Dialog/OpenDialogButton";
interface AddProjectTemplateButtonProps {
    project: ProjectResource;
    doBusyTask: DoBusyTask;
}
export function IncludeLibraryVariableSetsButton({ project, doBusyTask }: AddProjectTemplateButtonProps) {
    const dispatchAction = useAnalyticActionDispatch();
    const handleSelection = async (selectedSets: ReadonlyArray<string>) => {
        await doBusyTask(async () => {
            const allSets = await loadAllVariableSetIdentifiers();
            const nonVariableSets = project.IncludedLibraryVariableSetIds.filter((set) => !allSets.has(set));
            await repository.Projects.modify({ ...project, IncludedLibraryVariableSetIds: [...selectedSets, ...nonVariableSets] });
            dispatchAction("Include Library Variable Sets", { resource: "Variable", action: Action.Add });
        });
    };
    return (<OpenDialogButton label={"Include Library Variable sets"} type={ActionButtonType.Primary}>
            <VariableSetSelector spaceId={project.SpaceId} selectedVariableSetIds={project.IncludedLibraryVariableSetIds} saveVariableSetsSelection={handleSelection}/>
        </OpenDialogButton>);
}
async function loadAllVariableSetIdentifiers() {
    const allIdentifiers = await repository.LibraryVariableSets.all({ contentType: VariableSetContentType.Variables });
    return new Set(allIdentifiers.map((set) => set.Id));
}
